var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPenBold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3630_11392)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.833 2.64298C15.6329 2.64298 15.4348 2.6824 15.2499 2.75897C15.0651 2.83554 14.8971 2.94778 14.7556 3.08926L3.6621 14.1828L2.85404 17.1457L5.81692 16.3376L16.9104 5.24409C17.0519 5.1026 17.1642 4.93463 17.2407 4.74976C17.3173 4.5649 17.3567 4.36677 17.3567 4.16667C17.3567 3.96658 17.3173 3.76844 17.2407 3.58358C17.1642 3.39872 17.0519 3.23075 16.9104 3.08926C16.7689 2.94778 16.601 2.83554 16.4161 2.75897C16.2313 2.6824 16.0331 2.64298 15.833 2.64298ZM14.6121 1.21917C14.9992 1.05884 15.4141 0.976318 15.833 0.976318C16.252 0.976318 16.6669 1.05884 17.0539 1.21917C17.441 1.3795 17.7927 1.6145 18.0889 1.91075C18.3852 2.207 18.6202 2.5587 18.7805 2.94578C18.9409 3.33285 19.0234 3.74771 19.0234 4.16667C19.0234 4.58564 18.9409 5.0005 18.7805 5.38757C18.6202 5.77464 18.3852 6.12635 18.0889 6.4226L6.83895 17.6726C6.7364 17.7751 6.60887 17.8492 6.46896 17.8873L1.88562 19.1373C1.59711 19.216 1.28856 19.1341 1.0771 18.9226C0.865646 18.7111 0.783706 18.4026 0.862391 18.1141L2.11239 13.5307C2.15055 13.3908 2.22456 13.2633 2.3271 13.1608L13.5771 1.91075C13.8734 1.6145 14.2251 1.3795 14.6121 1.21917Z",
    fill: "#68666C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3630_11392"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPenBold);
export default __webpack_public_path__ + "static/media/icon-pen-bold.d70a71b85b0eded749a741d35fc01f83.svg";
export { ForwardRef as ReactComponent };